// IPFS
//export const DEFAULT_IPFS_GATEWAY = "https://ipfs.io";
//export const DEFAULT_IPFS_GATEWAY = "https://cloudflare-ipfs.com";
export const DEFAULT_IPFS_GATEWAY = "https://ipfs-gateway-dev.dappnode.net";
export const DEFAULT_IPFS_API = "https://api.ipfs.dappnode.io/";
export const LEGACY_IPFS_GATEWAY = "https://gateway-dev.ipfs.dappnode.io";

export const SDK_GUIDE_LINK =
  "https://github.com/dappnode/DAppNodeSDK/wiki/DAppNode-SDK-tutorial";
export const SDK_INSTALL_URL = "https://github.com/dappnode/DAppNodeSDK";

export const signatureFileName = "signature.json";
export const manifestFileName = "dappnode_package.json";

// Propagation
export const DEFAULT_PROPAGATION_URL =
  process.env.REACT_APP_PROPAGATION_URL || "https://bot.dappnode.net";
